import type { ComponentProps, ReactNode } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';

const StyledButton = styled(ButtonBase)`
  display: block;
  font-size: inherit;
  color: var(--c-blue-400);
`;

export const createResendEmailConfirmationButton = (
  buttonProps: ComponentProps<typeof ButtonBase>
) => {
  return function Link(chunks: ReactNode[]) {
    return (
      <StyledButton type="button" {...buttonProps}>
        {chunks}
      </StyledButton>
    );
  };
};
